import {
	NodeViewContent,
	type NodeViewProps,
	NodeViewWrapper,
} from '@tiptap/react'

const Component = (props: NodeViewProps) => {
	return (
		<NodeViewWrapper>
			<NodeViewContent className="[&>*]:flex [&>*]:gap-4" />
		</NodeViewWrapper>
	)
}

export default Component
